import {Column} from "react-table";
import {TableCustomCell} from "../../component/table/components/TableCustomCell";
import {IReportingPeriods} from "../models/reportAssignment"
import {TableCustomHeader} from "../../component/table/components/TableCustomHeader";
import {formatDateToDDMMYYYY} from "../../utils/FormatUtils";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";

export const ColumnsAssessmentPeriod: ReadonlyArray<Column<IReportingPeriods>> = [
  {
    Header: (props) => (
      <TableCustomHeader<IReportingPeriods>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces w-60px"
      />
    ),
    id: "stt",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center "
        data={String(props?.row?.index + 1)}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<IReportingPeriods>
        tableProps={props}
        title="TT"
        className="text-center text-light spaces w-60px"
      />
    ),
    id: "status",
    Cell: ({...props}) => (
      <div className="text-center">
        <i className="bi bi-circle-fill" style={{color: props.data[props.row.index]?.color}}></i>
      </div>
    )
    ,
  },
  {
    Header: (props) => (
      <TableCustomHeader<IReportingPeriods>
        tableProps={props}
        title="Tên đợt"
        className="text-center text-white align-middle bg-pri spaces min-w-400"
      />
    ),
    id: "name",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-align-left s-2"
        data={props.data[props.row.index]?.name}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<IReportingPeriods>
        tableProps={props}
        title="SL phần"
        className="text-center text-white align-middle bg-pri spaces w-140px"
      />
    ),
    id: "criteriaQty",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-align-left s-2"
        data={props.data[props.row.index]?.criteriaQty}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<IReportingPeriods>
        tableProps={props}
        title="Ngày phân công"
        className="text-center text-white align-middle bg-pri spaces max-w-200"
      />
    ),
    id: "assignmentDate",
    Cell: ({...props}) => (
      <TableCustomCell
        className="text-center s-2"
        data={formatDateToDDMMYYYY(props.data[props.row.index]?.assignmentDate)}
      />
    ),
  },
];

export const ColumnActionsAssessmentPeriod = (props: any) => {
  const {setDetailItem, setItemSelected, handleEdit} = props;
  return {
    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className='text-center text-light spaces w-100'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <div className="d-flex justify-content-center gap-3">
        {
          <CustomIconButton
            // tooltip={EDIT_ICON_TOOLTIPS[props.cell.row.original?.statusCode]}
            variant="edit"
            onClick={() => {
              handleEdit(props.cell.row.original);
              setItemSelected(props.cell.row.original);
              setDetailItem(props.cell.row.original);
            }}
          >
            <i className="bi bi-pencil-square text-navy"></i>
          </CustomIconButton>
        }
      </div>
    )
  }
}